<script>
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  props: ["Id"],
  data() {
    return {
      TableData: null,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    Loader,

  },
  watch: {
    Id() {
      if (this.Id) {
        this.FilterGet()
      }
    },
  },
  methods: {
    Get() { },
    FilterGet() {

      this.ActionsFilterGet({ Service: "StrIsoIzlemKriterleriBirim", Page: this.Page, Filter: "&Onay=true&Kriterid=" + this.Id }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal id="BirimIyılestirmeleri" size="xl" title="Birim İzleme Kriterleri" title-class="font-18" hide-footer>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Birim</th>
              <th>Veri</th> 
            </tr>
          </thead>
          <tbody>
            <tr v-for="Data in TableData" :key="Data.Id">
              <th scope="row">{{ Data.Birim }}</th>
              <td>{{ Data.Veri }}</td> 
            </tr>
          </tbody>
        </table>
        <br />
        <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
          :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
          @input="ChangePage(DefaultPage)"> </b-pagination>
      </div>


    </b-modal>
  </Loader>
</template>
